import * as d3 from 'd3';

// Écartement de l'anneau pour items co-localisés. Les bornes basses (count 2-3)
// sont inchangées ; les hautes sont nettement élargies pour que les gros
// clusters (jusqu'à ~18 items au même point) ne se chevauchent plus. clamp pour
// que les paquets > 18 ne divergent pas. textSpacer* > circleSpacer à tout count
// → libellés toujours hors des pastilles.
const textSpacerX = d3.scaleLinear().domain([2, 18]).range([0.2, 0.5]).clamp(true);
const textSpacerY = d3.scaleLinear().domain([1, 18]).range([0.18, 0.52]).clamp(true);
const circleSpacer = d3.scaleLinear().domain([2, 18]).range([0.08, 0.42]).clamp(true);

const baseMargin = 0.19;
const stakesMargin = 0.12;

const stakeTextSpacerX = d3.scaleLinear().domain([2, 9]).range([0.2, 0.3]);
const stakeTextSpacerY = d3.scaleLinear().domain([1, 9]).range([0.18, 0.3]);
const stakeCircleSpacer = d3
	.scaleLinear()
	.domain([2, 9])
	.range([0.08, 0.18]);

const circlePlacementDx = (d, similarStakes) => {
	// Répartition des points en fonction de leur index en cercle autour du point d'origine 0, 0
	const similarCount = similarStakes[d.id].similarCount;
	const index = similarStakes[d.id].index;

	if (similarCount == 0) return 0;

	const angle = (2 * Math.PI * index) / (similarCount + 1);
	const dx = Math.sin(angle);

	return dx;
};

const circlePlacementDy = (d, similarStakes) => {
	// Répartition des points en fonction de leur index en cercle autour du point d'origine 0, 0
	const similarCount = similarStakes[d.id].similarCount;
	const index = similarStakes[d.id].index;

	if (similarCount == 0) return 0;

	const angle = (2 * Math.PI * index) / (similarCount + 1);
	const dy = Math.cos(angle);

	return dy;
};

const textDx = (d, similarStakes, width, margin) => {
	if (Math.abs(circlePlacementDx(d, similarStakes) * 10) < 0.1) return 0;

	let count = Math.min(similarStakes[d.id].similarCount, 18);
	if (circlePlacementDx(d, similarStakes) > 0)
		return (
			textSpacerX(count) *
			(width * margin) *
			circlePlacementDx(d, similarStakes)
		);
	if (circlePlacementDx(d, similarStakes) < 0)
		return (
			textSpacerX(count) *
			(width * margin) *
			circlePlacementDx(d, similarStakes)
		);
	return 0;
};

const textDy = (d, similarStakes, width, margin) => {
	if (similarStakes[d.id].similarCount == 0) return 0;

	let count = Math.min(similarStakes[d.id].similarCount, 18);
	return (
		textSpacerY(count) *
			(width * margin) *
			circlePlacementDy(d, similarStakes) +
		11
	);
};

const circleDx = (d, similarStakes, width, margin) => {
	if (Math.abs(circlePlacementDx(d, similarStakes) * 10) < 0.1) return 0;

	let count = Math.min(similarStakes[d.id].similarCount, 18);
	if (circlePlacementDx(d, similarStakes) > 0)
		return (
			circleSpacer(count) *
			(width * margin) *
			circlePlacementDx(d, similarStakes)
		);
	if (circlePlacementDx(d, similarStakes) < 0)
		return (
			circleSpacer(count) *
			(width * margin) *
			circlePlacementDx(d, similarStakes)
		);
	return 0;
};

const circleDy = (d, similarStakes, width, margin) => {
	if (similarStakes[d.id].similarCount == 0) return 0;

	let count = Math.min(similarStakes[d.id].similarCount, 18);
	return (
		circleSpacer(count) *
		(width * margin) *
		circlePlacementDy(d, similarStakes)
	);
};

export {
	textSpacerX,
	textSpacerY,
	circleSpacer,
	baseMargin,
	circlePlacementDx,
	circlePlacementDy,
	textDx,
	textDy,
	circleDx,
	circleDy,
	stakesMargin
};
